import { createText } from '@shopify/restyle'

import { Theme } from '../utils/theme'

export const Text = createText<Theme>()